import { createSelector } from '@reduxjs/toolkit';
import { selectFloorsCount } from 'shared/selectors/jsonQuery';

export const selectFloorsCountFilter = createSelector(selectFloorsCount, ({ gte = null, lte = null }) => ({
  label: 'Этажей в доме',
  valueMin: gte,
  valueMax: lte,
  min: 1,
  max: 200,
}));
